import ArrowLinkIcon from 'ui-component-library/icons/arrow-link.svg'
import Link from 'content-components/_Primatives/Link'
import style from './style.scss'

type Props = {
  backToLinkText: string
  wodDate: string
}

function BackToWodLink({ wodDate, backToLinkText }: Props) {
  const url = `/${wodDate}`

  return (
    <Link className={style.wrapper} url={url}>
      <ArrowLinkIcon className={style.arrowLinkIcon} />
      {backToLinkText} {wodDate}
    </Link>
  )
}

export default BackToWodLink
